import OperationsHistory from './OperationsHistory';

export default OperationsHistory;
